<template>
  <el-button
    :disabled="disabled"
    type="danger"
    icon="el-icon-delete"
    size="mini"
    @click.stop.prevent="onClick"
  />
</template>

<script>
export default {
  props: {
    disabled: {
      type: Boolean,
      default() {
        return false;
      },
      required: false,
    },
  },
  methods: {
    onClick() {
      this.$emit('delete');
    },
  },
};
</script>
